import axios from "axios";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {obtenerPesoTotal} from "./obtenerPesoTotal";
import {obtenerDimenciones} from "./obtenerDimenciones";
import {obtenerValorTotal} from "./obtenerValorTotal";
import {BODEGA, NOMBREPEDIDO} from "../Constantes";
import {obtenerCodigoDane} from "./obtenerCodigoDane";

export const obtenerCotizacionesEnvio = async ({pedido}) => {



    let pesoTotal = obtenerPesoTotal(pedido.productos)
    let dimenciones = obtenerDimenciones(pedido.productos)
    let valorTotal = obtenerValorTotal(pedido.productos)
    let codigoDane = obtenerCodigoDane(pedido)

    let data = JSON.stringify(
        {
            "packages": [
                {
                    "weight": pesoTotal,
                    "height": dimenciones.alto,
                    "width": dimenciones.largo,
                    "length": dimenciones.fondo
                }
            ],
            "description": NOMBREPEDIDO,
            "contentValue": valorTotal,
            "codValue": valorTotal > 1800000 ? 1700000 : valorTotal,
            "includeGuideCost": false,
            "codPaymentMethod": "cash",
            "origin": {
                "daneCode": BODEGA.codigo,
                "address": BODEGA.direccion
            },
            "destination": {
                "daneCode": codigoDane + '000',
                "address": pedido.direccion ? pedido.direccion : 'Calle 2'
            }
        });

    let config = {
        method: 'post',
        url: 'https://api.envioclickpro.com.co/api/v2/quotation',
        headers: {
            'Authorization': 'd579cb35-81f8-4590-8d71-19cb90221223',
            'Content-Type': 'application/json'
        },
        data: data
    };

    return new Promise((resolve) => {
        axios(config)
            .then(function (response) {
                // console.log(response.data)
                if (response.status === 200) {
                    return resolve({res: true, data: response.data.data.rates})
                } else {
                    return resolve({res: false, data: "error interno"})
                }

            })
            .catch(function (error) {
                console.log(error)
                let obj = {
                    nombre: "Generando Guia",
                    fecha: new Date().getTime(),
                    datos: JSON.stringify(error)
                }
                guardarDoc('errores', obj).then()
                return resolve({res: false, data: error.message})

            });

    })


}